import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getServicesRequest } from "../../../../../redux/inspection-firms/slice";
import { Card, Box, Typography, Divider, Button } from "@mui/material";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import Loading from "../../../../../components/loading/loading";
import "./services.css";
import EditServices from "./edit-services/edit-services";

type props = {
  data: any;
};

const Services = ({ data }: props) => {
  const dispatch = useDispatch();
  const [showEditServices, setShowEditServices] = useState(false);

  useEffect(() => {
    dispatch(getServicesRequest({ id: data?.id }));
  }, [data, dispatch]);

  const { loading, services } = useSelector(
    (state: any) => state.inspectionFirms
  );

  const handleEditServices = () => {
    setShowEditServices(true);
  };

  return (
    <>
      <Card className="card-layout">
        <Box className="card-header">
          <Typography variant="h5">Services Offered</Typography>
          <Button
            variant="text"
            startIcon={<EditOutlinedIcon />}
            onClick={handleEditServices}
          >
            Edit
          </Button>
        </Box>
        <Box className="user-name-layout">
          <Typography className="label-txt">Agency Inspections</Typography>
          <Box>
            {services?.agencyInspections?.length > 0
              ? services?.agencyInspections?.map((inspection: any) => (
                  <Typography>{inspection?.displayName}</Typography>
                ))
              : "-"}
          </Box>
        </Box>
        <Divider />
        <Box className="user-name-layout">
          <Typography className="label-txt">
            Commercial Property <br />
            Inspections
          </Typography>
          <Box>
            {services?.commercialInspections?.length > 0
              ? services?.commercialInspections?.map((inspection: any) => (
                  <Typography>{inspection?.displayName}</Typography>
                ))
              : "-"}
          </Box>
        </Box>
        <Divider />
        <Box className="user-name-layout">
          <Typography className="label-txt">
            Residential Property <br />
            Inspections
          </Typography>
          <Box>
            {services?.residentialInspections?.length > 0
              ? services?.residentialInspections?.map((inspection: any) => (
                  <Typography>{inspection?.displayName}</Typography>
                ))
              : "-"}
          </Box>
        </Box>
        <Divider />
        <Box className="user-name-layout">
          <Typography className="label-txt">
            Specialty Inspections
          </Typography>
          <Box>
            {services?.specialtyInspections?.length > 0
              ? services?.specialtyInspections?.map((inspection: any) => (
                  <Typography>{inspection?.displayName}</Typography>
                ))
              : "-"}
          </Box>
        </Box>
        <Typography
          sx={{
            color: "rgba(0, 0, 0, 0.6) !important",
            mt: 2,
            fontStyle: "italic",
            fontSize: "14px",
          }}
        >
          *In order to receive these types of inspections, at least 1 certified
          inspector must be active in your firm.
        </Typography>
      </Card>
      {loading && <Loading />}
      {showEditServices && (
        <EditServices
          showDialog={showEditServices}
          closeDialog={() => {
            setShowEditServices(false);
          }}
          data={{ ...services, id: data?.id }}
        />
      )}
    </>
  );
};

export default Services;
